module.exports = __webpack_public_path__ + "img/cross.9e6555bd.png";